<template>
  <div class="home result-main-page font-sans w-full" :key="update_list">
    <div class="bg-results relative">
      <header-dark theme="main-text" class="pt-2 sm:pt-10" @auth="auth"></header-dark>
      <!-- first section -->
      <section
        class="pt-8 lg:py-8 xl:py-8 relative text-main-text result-container mx-auto"
      >
        <authorization-base :is_login="login" @auth="auth" />
        <div
          class="mx-auto lg:result-container xl:result-container pt-2 sm:pt-8 lg:py-8 xl:py-8 block-width w-full lg:px-0 xl:px-0"
        >
          <!-- desktop -->
          <div class="hidden sm:block">
            <div class="sm:flex content-center justify-between">
              <img
                class="mt-40"
                src="@/assets/SVG/rating-page-text.svg"
                alt=""
              />
            </div>
            <p class="text-lg mt-12 leading-xtight" style="color: white">
              Играйте офлайн, набирайте баллы за участие и победу!<br />
              Соревнуйтесь с другими классными командами города.<br />
              А ярким финалом каждого сезона будет специальная<br />игра – Лига
              чемпионов Мозгобойни!
            </p>
          </div>

          <!-- mobile -->
          <div class="sm:hidden">
            <div class="flex content-center justify-between rating-header mt-4">
              <img
                class=""
                src="@/assets/SVG/rating-page-text-mobile.svg"
                alt=""
              />
            </div>
            <p class="rating-paragraph" style="margin-top: 7%">
              Играйте офлайн, набирайте баллы<br />
              за участие и победу! Соревнуйтесь<br />с другими классными
              командами<br />
              города. А ярким финалом каждого<br />
              сезона будет специальная игра –<br />
              Лига чемпионов Мозгобойни!
            </p>
          </div>
        </div>
      </section>

      <!-- arrow down -->
      <div class="arrow-down">
        <font-awesome-icon
          :icon="['fal', 'angle-down']"
          class="fw-down text-6xl cursor-pointer tap-no-bgr arrow"
          style="color: #ffffff"
          @click="scrollInto('result-table')"
        ></font-awesome-icon>
      </div>
    </div>

    <!-- section what is raiting command-->
    <section ref="result-table" class="result-container my-12 lg:my-20 mx-auto">
      <!-- header mobile -->
      <h1 class="text-brand-darker text-2xl leading-normal lg:hidden">
        Что такое<br />
        рейтинг команд?
      </h1>

      <div class="block lg:flex">
        <div class="w-1/2">
          <!-- header desktop -->
          <h1 class="text-main-text text-4xl hidden lg:block">
            Что такое<br />
            рейтинг команд?
          </h1>
          <!-- text desktop -->
          <p
            class="text-main-text text-lg hidden lg:block mt-12"
            style="line-height: 22px"
          >
            Рейтинг делится на две категории:<br class="hidden lg:block" />общий
            рейтинг за все игры и рейтинг<br class="hidden lg:block" />
            Лиги чемпионов. <br class="hidden lg:block" /><br
              class="hidden lg:block"
            />
            Общий рейтинг формируется по итогам<br class="hidden lg:block" />
            всех игр Мозгобойни и накапливается<br class="hidden lg:block" />
            за все время вашего участия. <br class="hidden lg:block" />
            <br class="hidden lg:block" />
            Рейтинг Лиги Чемпионов формируется<br class="hidden lg:block" />
            в течение игрового сезона в городе.<br class="hidden lg:block" />
            По итогам сезона для лучших команд мы<br class="hidden lg:block" />
            проводим специальную игру <br class="hidden lg:block" />
            с мощными призами.
          </p>
        </div>
        <!-- video -->
        <div
          class="video w-full mt-6 lg:mt-0 h-54 md:h-100 lg:h-84 xl:h-100 lg:w-1/2"
        >
          <div class="video-player bg-gray-400">
            <div
              v-if="!videoIsPlay"
              class="video-stub flex justify-center items-center"
            >
              <div
                class="flex flex-col items-center cursor-pointer text-white"
                @click="playVideo"
              >
                <img
                  class="w-8 h-8 mb-4"
                  src="../../assets/SVG/rating-video-play-button.svg"
                  alt="play"
                />
              </div>
            </div>
            <youtube
              ref="youtube"
              :video-id="'PgsyKzaR-oM'"
              width="99%"
              height="99%"
            ></youtube>
          </div>
        </div>
      </div>

      <!-- text-mobile -->
      <p
        class="text-main-text mt-4 text-xs md:text-lg md:leading-tight lg:hidden"
        style="line-height: 15px"
      >
        Рейтинг делится на две категории: общий<br />
        рейтинг за все игры и рейтинг Лиги<br />
        чемпионов.<br /><br />

        Общий рейтинг формируется по итогам всех<br />
        игр Мозгобойни и накапливается за все<br />
        время вашего участия.<br /><br />

        Рейтинг Лиги чемпионов формируется<br />
        в течение игрового сезона в городе.<br />
        По итогам сезона для лучших команд мы<br />
        проводим специальную игру с мощными<br />
        призами.
      </p>
    </section>

    <!-- new brave world section-->
    <section class="result-container lg:my-24 mx-auto relative">
      <div class="lg:flex">
        <!-- what's rank -->
<!--        <span class="absolute underline font-medium text-sm cursor-pointer mt-16 lg:mt-0" @click="whatsRankModal = true">Что такое ранги?</span>-->
        <!-- header mobile -->
        <h1 class="text-main-text text-2xl leading-normal lg:hidden">
          <span style="border-bottom: 4px solid #bd006c; padding-bottom: 10px"
            >Новый</span
          >
          дивный мир!
        </h1>
        <!-- text-mobile -->
        <p
          class="text-main-text mt-16 text-xs md:text-lg md:leading-tight lg:hidden"
          style="line-height: 15px"
        >
          Баллы общего рейтинга влияют на ранг<br />
          вашей команды среди других игроков. Но мы<br />
          придумали не просто ранговую систему, это<br />
          целая вселенная со своей историей<br />
          и правилами! Окунитесь в нее прямо сейчас<br />
          и расскажите всем участникам команды!
        </p>

        <!-- img -->
        <img
          class="mt-4 lg:mt-0 w-full lg:w-3/5 h-full"
          src="@/assets/new-brave-world-background.png"
          alt
        />

        <!-- button to open modal -->
        <div class="w-full flex lg:block justify-center lg:w-2/5 max-w-100 ">
          <!-- header desktop -->
          <h1 class="text-main-text text-4xl leading-normal lg:block hidden">
            Новый дивный мир!
          </h1>
          <p
            style="border-bottom: 4px solid #bd006c; padding-bottom: 10px"
            class="w-16 mt-8 hidden lg:block"
          ></p>
          <!-- text desktop -->
          <p
            class="text-main-text mt-8 text-xs md:text-lg md:leading-tight lg:block hidden"
            style="line-height: 15px"
          >
            Баллы общего рейтинга влияют на ранг вашей команды среди других
            игроков. Но мы придумали
            не просто ранговую систему, это целая вселенная
            со своей историей и правилами! Окунитесь в нее прямо сейчас и
            расскажите всем участникам команды!

          </p>

          <button
            @click="carouselOpen = true"
            class="more-about-ranks-btn text-sm mt-6 text-main-text lg:mt-16 hover-up"
          >
            Подробнее о рангах
          </button>
        </div>
      </div>
    </section>

    <!-- section of tables -->
    <section class="result-container mx-auto mb-16 lg:mb-24 mt-12 lg:mt-40">
      <!-- result header -->
      <div class="w-full sm:flex mb-10">
        <div class="result-header">
          <h1
            class="text-brand-darker lg:text-main-text lg:text-4xl text-2xl leading-normal mb-8"
          >
            Рейтинг команд
          </h1>
          <div class="ml-auto how-rating-calculater md:hidden -mt-2 mb-8">
            <p @click="ratingRuleModalopen(true)">
              Как рассчитывается рейтинг?
            </p>
          </div>
          <div class="flex">
            <button
              class="general mr-6 text-main-text hover-up"
              :class="{ 'button-active': buttonActive }"
              @click="changeRatingTableType(true, 'general')"
            >
              Общий рейтинг
            </button>
            <button
              class="champions text-main-text hover-up"
              :class="{ 'button-active': !buttonActive }"
              @click="changeRatingTableType(false, 'champions')"
            >
              Лига чемпионов
            </button>
          </div>
          <p v-if="buttonActive" style="height: 75px">
            Смотрите баллы своей команды, сравнивайте с другими и ставьте новые
            цели!<br class="hidden lg:block" />
            Чем больше баллов, тем выше статус и больше привилегий.
          </p>
          <p v-else style="height: 75px">
            Участвуйте в играх сезона, набирайте баллы, чтобы соревноваться в
            финальной битве.
            <br />В зачет идут только результаты классических и специальных игр.
            Этот рейтинг обнуляется с началом нового сезона.
          </p>
        </div>
        <div class="ml-auto how-rating-calculater hidden md:block">
          <p @click="ratingRuleModalopen(true)">Как рассчитывается рейтинг?</p>
        </div>
      </div>

      <!-- result table -->
      <mozgo-table :ratingTableType="ratingTableType"></mozgo-table>
    </section>

    <!-- FAQ  -->
    <section class="result-container mx-auto mb-12 lg:mb-24">
      <rating-faq/>
    </section>

    <home-footer/>

    <!-- rating rule modal-->
    <ratingRuleModal
      v-if="ratingRuleModal"
      @close="ratingRuleModalopen(false)"/>

    <!-- carousel modal  -->
    <ratingPageCarosule
      @close="closeCarousel"
      v-if="carouselOpen"/>

    <!-- what's rank modal -->
    <modal classes="xmd:w-full mx-auto overflow-auto pb-4 max-w-xsm xmd:max-w-xl bg-white" v-if="whatsRankModal" @close="whatsRankModal = false">
    <div class="whats-rank-modal px-10 pb-10 pt-4">
        <h1>Что такое ранги?</h1>

        <div class="mt-10">
          <p class="text-sm">Ранги команд – это система лояльности, в которой команды за достижение определенного количества баллов получают ранг, а вместе с ним – различные бонусы.</p>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import base from '@/clients/base';
import client from '@/clients/player';
import ShowProfile from '../show-profile.vue';
import parse from 'date-fns/parse';
import SelectCity from '../select-city.vue';
import Payment from './paymentModals/payment.vue';
import HomeHead from '../home-page-layouts/home-head';
import HomeFooter from './home-footer';
import FilterGames from './components/filter-games';
import HeaderDark from './components/header-dark';
import Pagination from '@/helpers/pagination/pagination.vue';
import GamesFilter from '@/helpers/pagination/filter.vue';
import ratingRuleModal from '@/views/modals/rating-rule-modal.vue';
import ratingPageCarosule from '@/views/home-page-layouts/components/ratingPageCarosule.vue';
import ratingFaq from '@/views/home-page-layouts/components/ratingFaq.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import AuthorizationBase from '@/helpers/auth/authorization';
import uuid from 'uuid';
import MozgoTable from '@/views/home-page-layouts/Table/MozgoTable';
import axios from 'axios';
import modal from '@/views/modals/new-base-modal.vue';

export default {
  name: 'Result',
  components: {
    MozgoTable,
    HomeFooter,
    HomeHead,
    Payment,
    SelectCity,
    ShowProfile,
    FilterGames,
    HeaderDark,
    GamesFilter,
    Pagination,
    AuthorizationBase,
    ratingRuleModal,
    ratingPageCarosule,
    ratingFaq,
    modal,
  },
  data() {
    return {
      carouselOpen: false,
      showProfile: false,
      videoIsPlay: false,
      showCity: false,
      client: base,
      login: false,
      ratingRuleModal: false,
      buttonActive: true,
      whatsRankModal: false,
      ratingTableType: 'general',
      data: [],
      update_list: uuid(),
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {
    city() {
      return this.$store.getters.cityProps.city || '';
    },
  },
  methods: {
    ...mapActions({
      setRemoveDefaultCity: 'setRemoveDefaultCity',
    }),
    auth() {
      this.login = !this.login;
    },
    ratingRuleModalopen(value) {
      if (value === true) {
        this.ratingRuleModal = true;
        document.body.classList.add('body-modal-open');
      } else {
        this.ratingRuleModal = false;
        document.body.classList.remove('body-modal-open');
      }
    },
    scrollInto(refName) {
      const elem = this.$refs[refName];
      elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    changeRatingTableType(value, ratingType) {
      this.ratingTableType = ratingType;
      this.buttonActive = value;
      // if(ratingType ==='general'){
      //   this.setRemoveDefaultCity(false)
      // }else{
      //   this.setRemoveDefaultCity(this.city)
      // }
    },
    playVideo() {
      this.$refs.youtube.player.playVideo();
      this.videoIsPlay = true;
    },
    closeCarousel() {
      this.carouselOpen = false;
      document.body.classList.remove('body-modal-open');
    },
  },
  watch: {
    city_id() {
      this.update_list = uuid();
    },
  },
};
</script>
<style lang="less" scoped>
.hover-up {
  transition: all 0.5s;
  &:hover {
    transform: translateY(-3px);
    @apply shadow-md;
  }
}
.bg-results {
  width: 100%;
  background-image: url("../../assets/SVG/rating-background.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #ffce42;
  height: 100vh;
}
.arrow-down {
  position: absolute;
  bottom: 0rem;
  height: 7rem;
  width: 100%;
  display: grid;
  place-content: center;
}
.arrow-down {
  -webkit-animation: arrow 1.5s linear infinite;
  animation: arrow 1.5s linear infinite;
  animation-direction: alternate;
}
@keyframes arrow {
  0% {
    bottom: 6%;
  }
  100% {
    bottom: 0%;
  }
}
.result-header p {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.how-rating-calculater p {
  text-decoration: underline;
  cursor: pointer;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
}
.result-header .general,
.champions {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  width: 192px;
  height: 39px;
  left: 360px;
  top: 945px;
  background: #ffffff;
  border: 1px solid #dadada;
  border-radius: 45px;
  margin-bottom: 24px;
  outline: none;
}
.more-about-ranks-btn {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  min-width: 250px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dadada;
  border-radius: 45px;
  margin-bottom: 24px;
  outline: none;
}

.result-header .button-active {
  border: 2px solid #bd006c;
}
.rule1 {
  margin-top: 37px;
}
.result-container {
  width: 80%;
}

.video-player {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-stub {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: url("../../assets/rating-video-background.png") 50% 50% no-repeat;
  background-size: cover;
}

.whats-rank-modal {
  max-width: 420px;
}

@media (max-width: 768px) {
  .result-container {
    width: 90%;
  }
}

@media screen and (min-width: 100px) and (max-width: 800px) {
  .bg-results {
    background: url("../../assets/rating-page-background-mobile.png") no-repeat;
    background-position: right center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 95vh;
  }
  .result-header p {
    font-size: 12px;
    line-height: 15px;
  }
  .how-rating-calculater {
    margin-top: 24px;
  }
  .rating-paragraph {
    display: block;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #ffffff;
  }
  .result-header .general,
  .champions {
    font-size: 0.8rem;
  }
}
</style>
